var _style, _path, _g, _g2, _g3, _g4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:url(#SVGID_1_);}\n\t.st1{fill:#002831;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.0812,
    y1: 260.5641,
    x2: 263.2094,
    y2: 27.4359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.7,275.7H52.6c-9.8,0-17.8-8-17.8-17.8V30.1c0-9.8,8-17.8,17.8-17.8h188.1c9.8,0,17.8,8,17.8,17.8v227.7 C258.5,267.7,250.6,275.7,240.7,275.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.2,166.3h89.6c10.4,0,18.9,8.5,18.9,18.9v37.1c0,10.4-8.5,18.9-18.9,18.9h-94.3l-14.2,14.2V234v-27.4 v-21.4C138.3,174.8,146.8,166.3,157.2,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.4,161.8h-34.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h34.2c0.3,0,0.5,0.2,0.5,0.5 C242.8,161.6,242.6,161.8,242.4,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.9,247.4h-82.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h82.5c0.3,0,0.5,0.2,0.5,0.5 S242.2,247.4,241.9,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.8,187.8v6.5h-5v25.9h-8.4v-25.9h-5v-6.5H189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.2,187.8v32.3h-8.4v-32.3H204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.5,187.8v32.3h-7.4l-4.4-14.7v14.7h-7v-32.3h7l4.7,14.6v-14.6H230.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.1,75.8H35.3c-9.2,0-16.8,7.6-16.8,16.8v33c0,9.2,7.6,16.8,16.8,16.8h130.1l12.6,12.6v-19v-24.3V92.7 C178,83.4,170.4,75.8,161.1,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.9,71H45.6c-0.2,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h67.2c0.2,0,0.5,0.2,0.5,0.5 C113.4,70.9,113.1,71,112.9,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.2,147.7H50.9c-0.2,0-0.5-0.2-0.5-0.5c0-0.2,0.2-0.5,0.5-0.5h44.3c0.2,0,0.5,0.2,0.5,0.5 C95.7,147.4,95.5,147.7,95.2,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.6,65.5H93.8c-0.2,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h67.8c0.2,0,0.5,0.2,0.5,0.5 C162,65.3,161.9,65.5,161.6,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,91.7v34.7h-7.9l-4.7-15.8v15.8h-7.6V91.7h7.6l5,15.7V91.7H81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.9,91.7v34.7h-9.1V91.7H98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.2,91.7v34.7h-7.9l-4.7-15.8v15.8h-7.6V91.7h7.6l5,15.7V91.7H127.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,205.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L66.7,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3,205.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L94.3,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122,205.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L122,205.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.7,202.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L69.7,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.3,202.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L97.3,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125,202.5l-4.5,4.5l5.6,2.7l-2,4.6l-5.8-2.4l-1.1,6.3l-4.9-0.8l0.9-6.5l-6.5,0.9l-0.8-5l6.4-1.2l-2.5-5.8 l4.5-2.1l2.9,5.7l4.5-4.5L125,202.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.2,102l-22.7,0.1l0-2.3c0-3.9,0.4-7,1.3-9.4c0.8-2.4,2.1-4.6,3.9-6.6c1.7-2,5.6-5.5,11.6-10.6 c3.3-2.7,4.8-5,4.8-7.2c0-2.2-0.7-3.9-2-5.1c-1.3-1.2-3.3-1.8-5.9-1.8c-2.8,0-5.1,1-7,2.8c-1.8,1.9-3,5.1-3.5,9.8L198.6,69 c0.7-8.5,3.8-15.4,9.2-20.6s13.6-7.9,24.8-7.8c8.7-0.1,15.7,1.8,21,5.4c7.3,4.9,10.9,11.4,10.9,19.5c0,3.4-0.9,6.7-2.7,9.8 c-1.8,3.2-5.7,7-11.4,11.6c-4,3.2-6.5,5.8-7.6,7.7C241.8,96.4,241.2,99,241.2,102z M217.8,108.2l24.4-0.1l0.1,21.4l-24.4,0.1 L217.8,108.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.2,96l-22.7,0.1l0-2.3c0-3.9,0.4-7,1.3-9.4c0.8-2.4,2.1-4.6,3.9-6.6c1.7-2,5.6-5.5,11.6-10.6 c3.3-2.7,4.8-5,4.8-7.2c0-2.2-0.7-3.9-2-5.1c-1.3-1.2-3.3-1.8-5.9-1.8c-2.8,0-5.1,1-7,2.8c-1.8,1.9-3,5.1-3.5,9.8L203.6,63 c0.7-8.5,3.8-15.4,9.2-20.6s13.6-7.9,24.8-7.8c8.7-0.1,15.7,1.8,21,5.4c7.3,4.9,10.9,11.4,10.9,19.5c0,3.4-0.9,6.7-2.7,9.8 c-1.8,3.2-5.7,7-11.4,11.6c-4,3.2-6.5,5.8-7.6,7.7C246.8,90.4,246.2,93,246.2,96z M222.8,102.2l24.4-0.1l0.1,21.4l-24.4,0.1 L222.8,102.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNin);
export default __webpack_public_path__ + "static/media/nin.0525817fa27ff75f774c6cb2387fba1c.svg";
export { ForwardRef as ReactComponent };